import { Component, OnInit } from '@angular/core';
import { DialogRef } from '@fundamental-ngx/core/dialog';
import { ResourceModel } from '../../../../core/models/resources/resource.model';
import { Const} from '../../../../core/helpers/Const';


@Component({
    selector: 'app-resource-has-content-dialog',
    templateUrl: './resource-has-content-dialog.component.html',
    styleUrls: ['./resource-has-content-dialog.component.scss'],
    standalone: false
})
export class ResourceHasContentComponent implements OnInit {
    resource: ResourceModel;
    type: string;
    msg: string;
    title: string;
    errorMsg: string;
    Const = Const;
    loading = false;


    constructor(
		public dialogRef: DialogRef,
    ) {}

    ngOnInit(): void {
        let data = this.dialogRef.data;
        this.type = 'warning';
        this.title = data.title;
        this.msg = data.msg;
    }
    onClose() {
        this.dialogRef.close(this.resource);
    }
    onCancel() {
        this.dialogRef.close(this.resource);

    }

    validate() {
        return !this.loading;
    }
}
